import { Connector } from '@lair-finance/wagmi/core'
import { isKaiaConnector, isKaikasConnector } from '@/domains/wallet/lib/connector.ts'
import { TokenImages, TokenTicker, TokenTickers } from '@/shared/config/token.ts'
import { APP_HOST } from '@/shared/config'
import { Address } from 'viem'

export class WalletExtension {
  public static isInstalled(connector: Connector): boolean {
    return isKaiaConnector(connector) || isKaikasConnector(connector) ? typeof window.klaytn !== 'undefined' : typeof window.ethereum !== 'undefined'
  }

  public static getProvider(connector: Connector) {
    return isKaiaConnector(connector) || isKaikasConnector(connector) ? window.klaytn : window.ethereum
  }

  public static addAsset(connector: Connector, ticker: TokenTicker, tokenAddress: Address): Promise<boolean> {
    const provider = this.getProvider(connector)
    return provider.request({
      method: 'wallet_watchAsset',
      params: {
        type: 'ERC20',
        options: {
          address: tokenAddress,
          symbol: TokenTickers[ticker],
          decimals: 18,
          image: APP_HOST + TokenImages[ticker],
        },
      },
    })
  }
}
